import React, { useEffect, useState } from 'react';
import { AuthStatus, Pagination, Questioner, ReduxState, Tokens, UserData } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Button, IconButton, Input, InputAdornment, TextField } from '@material-ui/core';
import './form.style.scss';
import logo from 'assets/images/logo/logo50_k.png';
import { API, RoutePath } from 'data';
import { Link } from 'react-router-dom';
import { get, post } from 'scripts/api';
import { authToken, userData } from 'scripts/storage';
import { toast } from 'react-toastify';
import { setAuthStatus, setExpire, setUserData } from 'redux/actions';
import { Spinner } from 'react-bootstrap';
import { MessageBridge } from 'scripts/messageBridge';
// import ReCAPTCHA from 'react-google-recaptcha';
// import ENV from 'env.json';

const Form: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.signin.form;
    const [username, setUsername] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [showPassword, setShowPassword] = useState<boolean | undefined>(false);
    const [load, setLoad] = useState(false);
    // const [captcha, setCaptcha] = useState<string>();

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        MessageBridge.message('BACK_BUTTON_ROOT_STATUS', true);
        return () => {
            MessageBridge.message('BACK_BUTTON_ROOT_STATUS', false);
        };
    }, []);

    function onClickHandler() {
        if (username && password) {
            const validation = true;
            // if (captcha === undefined || captcha.length === 0) {
            //     toast.error(lang.captchaErr);
            //     validation = false;
            // }
            if (validation) {
                setLoad(true);
                post<Tokens>(API.register.signin, {
                    email_or_username_or_phone: username,
                    password: password,
                    workspace_title: lang.myWS,
                    // captcha_token: captcha,
                })
                    .then((res) => {
                        props.dispatch(setExpire(false));
                        authToken.set(res.data);
                        get<UserData>(API.dashboard.profile.index)
                            .then((res) => {
                                setLoad(false);
                                props.dispatch(setUserData(res.data));
                                userData.set(res.data);
                                props.dispatch(setAuthStatus(AuthStatus.valid));
                            })
                            .catch((res) => {
                                authToken.remove();
                                props.dispatch(setAuthStatus(AuthStatus.inValid));
                                if (res.status >= 500) toast.error(props.lang.serverErr);
                                else if (res.status >= 400) toast.error(lang.err);
                                else toast.error(props.lang.unknownErr);
                            });
                    })
                    .catch((res) => {
                        setLoad(false);
                        if (res.status >= 500) toast.error(props.lang.serverErr);
                        else if (res.status >= 400) toast.error(lang.error);
                        else toast.error(props.lang.unknownErr);
                    });
            }
        }
    }

    return (
        <div className="signin-form">
            <div className="image-div">
                <img className="logo" src={logo} alt="logo" />
            </div>
            <TextField
                className="username"
                id="input-with-icon-textfield"
                InputProps={{
                    startAdornment: <i className="material-icons icon">person</i>,
                }}
                autoComplete="false"
                onChange={(e) => setUsername(e.target.value)}
                placeholder={lang.email}
            />
            <Input
                id="standard-adornment-password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                className="password"
                autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)}
                startAdornment={<i className="material-icons icon">lock</i>}
                placeholder={lang.password}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? (
                                <i className="material-icons eye-icon">visibility</i>
                            ) : (
                                <i className="material-icons eye-icon">visibility_off</i>
                            )}
                        </IconButton>
                    </InputAdornment>
                }
            />
            {/* <div className="mt-4">
                <ReCAPTCHA
                    sitekey={ENV.reCaptcha}
                    onChange={(e) => {
                        if (e) setCaptcha(e);
                    }}
                />
            </div> */}
            <div className="forget-pass">
                <a
                    target="_blank"
                    rel="noreferrer"
                    className="text"
                    href="https://new.ucheck.me/register/forgetPassword/"
                >
                    {lang.forgetPass}
                </a>
            </div>
            <div className="button-div">
                <Button
                    disabled={!username || !password || load}
                    onClick={onClickHandler}
                    className="enter-button"
                    variant="contained"
                    color="primary"
                    disableElevation
                >
                    {load ? <Spinner animation="border" /> : lang.enter}
                </Button>
            </div>
            <div className="end-line">
                <p className="question">{lang.question}</p>
                <span />
                <Link to={RoutePath.register.signIn.connectServer} className="enter-kiosk">
                    {lang.enterKiosk}
                </Link>
            </div>
            <div className="new-account">
                <p>حساب کاربری ندارید؟</p>
                <span></span>
                <a target="_blank" rel="noreferrer" href={'https://new.ucheck.me/register/signUp/'}>
                    ثبت نام
                </a>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Form);
